import { Component, OnInit,Inject,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import { Http, Response,Headers } from '@angular/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { NgForm } from '@angular/forms';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA,MatDialogRef} from '@angular/material';
import {CookieService} from 'angular2-cookie/core'

@Component({
  selector: 'app-enquiries',
  templateUrl: './enquiries.component.html',
  styleUrls: ['./enquiries.component.css'],
    providers: [HelperService]
})
export class EnquiriesComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }

 dtOptions: DataTables.Settings = {};
  dtElement: DataTableDirective;
  enquirys:any=[];
  dtTrigger: Subject<any> = new Subject();
enquiry_reply='';
btn_disable=false;
btn_class='btn';
user_permissions:any=[];
user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,public dialog: MatDialog,private cookie:CookieService) {
}
  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
  	this.http.get(this.helper.base_url+'http/get/enquiry',{ headers: this.headers })
      
      .subscribe(data => {
        this.enquirys = JSON.parse(data['_body']);
        
          this.dtTrigger.next();
        
       
      });

       this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      ordering: false
      // columnDefs :[
      //   { "orderable": false },
        // { "orderable": false, "targets": 1 },
        // { "orderable": false, "targets": 2 },
        // { "orderable": false, "targets": 3 },
        // { "orderable": false, "targets": 4 },
        // { "orderable": false, "targets": 5 },
        // { "orderable": false, "targets": 6 },
        // { "orderable": false, "targets": 7 },
        // { "orderable": false, "targets": 8 },
      //]
    };
    
  }
   
  enquiry_change(event,value)
{
  
 if(value!=''){
this.btn_disable=true;
this.btn_class='btn btn-primary';
 }else{
this.btn_disable=false;
this.btn_class='btn';
 }
}


   refresh(val=false){
   
  this.snackbar.open('Message sent successfully', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["enquiries"]));
      
 }
 openDialog(data) {
    const dialogRef = this.dialog.open(Reply2DialogBox, {
      height: '350px',
       width: '1000px',
      data: { data: data,base_url:this.helper.base_url },
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }
}

@Component({
  selector: 'reply-dialog-box',
  templateUrl: "reply-dialog-box.html",
})
export class Reply2DialogBox {
  users:any=[];
  foods:any=[];
 name='';
  query='';
 base_url;
 id;
  dialog=MAT_DIALOG_DATA;
  notificationdisbled =false;
  notifcatonloading = false;
  user=this.cookie.get('user_id');
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(public dialogRef: MatDialogRef<EnquiriesComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private http:Http,private snackbar: MatSnackBar,private router:Router,private cookie:CookieService,) {
    this.name=data.data.student;
    if(this.name == null){
      this.name=data.data.name;
    }
    this.query=data.data.query;
    this.base_url=data.base_url;
    this.id=data.data.id;
  
  }
  add_reply_enquiry(reply){
    
        if(reply!=''){

          this.notificationdisbled = true;
     this.notifcatonloading = true;
 this.http.get(this.base_url+'http/add/enquiry_reply?id='+this.id+'&reply='+reply,{ headers: this.headers })
      .subscribe(data => {
this.dialogRef.close();
        this.refresh() ;
      });
        }else{
  this.snackbar.open('Field Required', null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
        }
    
  } 
   refresh(val=false,msg=''){
   
  this.snackbar.open('Reply send successfully', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["enquiries/"]));
      
 }
  ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/enquiries/enquiries.component.ts